"use client"
import ForgotPassword from '@/components/auth/forgot';
import Login from '@/components/auth/login';
import Register from '@/components/auth/register';
import ResetPassword from '@/components/auth/resetpassword';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { Suspense, useEffect, useMemo } from 'react';
import { JSX } from 'react/jsx-runtime';
import PasswordReset from '@/components/auth/passwordreset';
import Loader from '@/app/loading';

 function Auth() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const type = searchParams.get("type");

  // Store components in an object for better readability & dynamic retrieval
  const authComponents: Record<string, JSX.Element> = useMemo(() => ({
    login: <Login />,
    register: <Register />,
    reset: <ResetPassword />,
    passwordreset:<PasswordReset/>,
    forgotpassword: <ForgotPassword />,
  }), []);

  useEffect(() => {
    if (!type || !authComponents[type]) {
      const newParams = new URLSearchParams(searchParams.toString());
      newParams.set("type", "login");
      router.replace(`${pathname}?${newParams.toString()}`);
    }
    // check for logout
  }, [type, searchParams, pathname, router, authComponents]);
  

  return type && authComponents[type] ? authComponents[type] : null;
}


export default function DashboardAuthPage() {
  return (
    <Suspense fallback={<Loader imageType='bar'/>}>
      <Auth />
    </Suspense>
  );
}